import z from "zod";
import { requiredBoolean, requiredId, requiredText } from "../lib/schemas";
//Para GET o DELETE por el Id que se pasa por Param
export const tagIdParamSchema = z.object({
    tagId: requiredId,
});
//Para respuesta del GET por id de la categoria
export const getTagOutputSchema = z.object({
    id: requiredId,
    name: requiredText,
    isBase: requiredBoolean,
});
//Para insert de la categoria por id
export const createTagInputSchema = z.object({
    name: requiredText,
});
export const updateTagInputSchema = z.object({
    name: requiredText,
});
